import { uni } from '@planne-software/uni/v2';
import { Box, Stack, styled } from '@planne-software/uni/mui/material';

import { uniTypography } from '@src/fonts/typography/uniTypography';

export const VoucherSummaryRoot = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: uni('scale-200'),
  width: '100%',
  minHeight: '40px',
  padding: uni('scale-200'),
  borderRadius: uni('border-radius-2xs'),
  border: `1px solid ${uni('border-static-content-default')}`,
  backgroundColor: uni('bg-static-content-default'),
}));

export const VoucherSummaryLabel = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: uni('scale-100'),
  color: uni('fg-neutral-static-default-body'),
}));

export const VoucherSummaryCount = styled('p')`
  ${uniTypography('text-sm', 'semibold')}
  color: ${uni('fg-neutral-static-default-body')};
  margin: 0;
`;

export const VoucherModalRoot = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  maxHeight: 'calc(100vh - 48px)',
  overflow: 'hidden',
  outline: 'none',
  backgroundColor: uni('bg-static-content-default'),
  borderRadius: uni('border-radius-md'),

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxHeight: '100dvh',
    borderRadius: `${uni('border-radius-md')} ${uni('border-radius-md')} 0 0`,
  },
}));

export const VoucherModalBody = styled(Stack)(() => ({
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  padding: uni('padding-content'),
  gap: uni('scale-600'),
}));

export const VoucherBlockRoot = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('spacing-24-16'),
  width: '100%',
}));

export const VoucherBlockDivider = styled(Box)(() => ({
  width: '100%',
  height: '1px',
  flexShrink: 0,
  backgroundColor: uni('bg-static-divider-default'),
}));

export const VoucherBlockTitle = styled('p')`
  ${uniTypography('text-sm', 'semibold')}
  color: ${uni('fg-neutral-static-default-body')};
  margin: 0;
`;

export const VoucherFieldRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: uni('scale-1000'),
  width: '100%',

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: uni('scale-200'),
  },
}));

export const VoucherField = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('scale-100'),
  flex: '1 0 0',
  minWidth: 0,
  width: '100%',
}));

export const VoucherFieldLabel = styled('p')`
  ${uniTypography('text-sm', 'medium')}
  color: ${uni('fg-neutral-static-default-caption')};
  margin: 0;
`;

export const VoucherFieldValue = styled('p')`
  ${uniTypography('text-sm', 'semibold')}
  color: ${uni('fg-neutral-static-default-body')};
  margin: 0;
  overflow-wrap: anywhere;
`;

export const VoucherModalFooter = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'flex-end',
  flexShrink: 0,
  gap: uni('scale-300'),
  padding: uni('padding-content'),
  borderTop: `1px solid ${uni('bg-static-divider-default')}`,
  backgroundColor: uni('bg-static-content-default'),

  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    right: 0,
    top: '-50px',
    height: '51px',
    pointerEvents: 'none',
    background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 24.51%, rgba(70, 70, 70, 0.1))',
  },

  [theme.breakpoints.down('sm')]: {
    '& > button': {
      width: '100%',
    },
  },
}));
